/* eslint-disable import/prefer-default-export */
import * as DOMPurify from 'dompurify';

export const safeHTML = (htmlString, config = {}) => {
  try {
    return DOMPurify.sanitize(htmlString, config);
  } catch (err) {
    return '';
  }
};
